import React from "react";

import { calculateCompanyCost, calculateEmployeesCost, calculateTotalCost } from "EmployerApplication/Components/ComprehensiveCostEstimation/CostCalculations";
import formatCurrency from "Utils/formatCurrency";

import { Table, TR, TD, TH } from "Cobalt/TableV2";
import BodyText from "Common/BodyText";
import { CONTRIBUTION_TYPES } from "Common/Constants";
import { Row, Col } from "Common/Grid";

import EmployeesTable from "./EmployeesTable";

import makeBem from "Utils/makeBem";

const bem = makeBem("CostBreakdown");

export const EmployeesSection = ({ employees, plans, contributionType, contributions, selectedVisionPlan, selectedDentalPlan }) => {
  let employeeSection;
  if (employees.length == 0) {
    employeeSection = (
      <TR>
        <TD colSpan="2">No employees added..</TD>
      </TR>
    );
  } else {
    employeeSection = (
      <EmployeesTable
        employees={employees}
        medicalPlans={plans}
        contributionType={contributionType}
        contributions={contributions}
        dentalPlan={selectedDentalPlan}
        visionPlan={selectedVisionPlan}
      />
    );
  }

  const noEmployeeEnrollments = employees.every((employee) => employee.is_enrolling === undefined);

  const employeeCost = formatCurrency(calculateEmployeesCost(employees, plans, selectedDentalPlan, selectedVisionPlan, contributionType, contributions));

  const companyCost = formatCurrency(calculateCompanyCost(employees, plans, selectedDentalPlan, selectedVisionPlan, contributionType, contributions));

  const totalCost = formatCurrency(calculateTotalCost(employees, plans, selectedDentalPlan, selectedVisionPlan));

  const columnSpan = [
    "nameColumn",
    "ageColumn",
    contributions[1],
    "medicalPlanColumn",
    selectedDentalPlan,
    selectedVisionPlan,
    "employeeShareColumn",
    "companyShareColumn",
    "totalCostColumn",
  ].filter((col) => col !== undefined && col !== null).length;

  const dentalPlanOffered = selectedDentalPlan !== undefined && selectedDentalPlan !== null;
  const visionPlanOffered = selectedVisionPlan !== undefined && selectedVisionPlan !== null;

  return (
    <Row>
      <Col>
        <Table mb={0}>
          <thead>
            <TR className={bem("TableHeader")}>
              <TH className={bem("EmployeeDetailsColumn")}>Person</TH>
              <TH className={bem("EmployeeDetailsColumnThin")}>Age</TH>
              {contributions.length > 1 && <TH className={bem("EmployeeDetailsColumn")}>Tier</TH>}
              <TH className={bem("EmployeeDetailsColumn")}>Medical</TH>
              {dentalPlanOffered && <TH className={bem("EmployeeDetailsColumnThin")}>Dental</TH>}

              {visionPlanOffered && <TH className={bem("EmployeeDetailsColumnThin")}>Vision</TH>}

              <TH align="right">Employee Share</TH>
              <TH align="right">Company Share</TH>
              <TH align="right">Total Cost</TH>
            </TR>
          </thead>
          <tbody id="employees-section">{employeeSection}</tbody>
          <tfoot className={bem("footer")}>
            {!noEmployeeEnrollments && (
              <TR>
                <TH colSpan={columnSpan - 4} />
                <TH align="right">Total</TH>
                <TH align="right">{`${employeeCost === "$NaN" ? "$0" : employeeCost}`}</TH>
                <TH align="right">{`${companyCost === "$NaN" ? "$0" : companyCost}`}</TH>
                <TH align="right">{`${totalCost === "$NaN" ? "$0" : totalCost}`}</TH>
              </TR>
            )}

            {noEmployeeEnrollments && (
              <TR>
                <TH colSpan={columnSpan - 1} />
                <TD className={bem("TotalCostColumn")} />
              </TR>
            )}
          </tfoot>
        </Table>
      </Col>
    </Row>
  );
};

export const contributionAmounts = (contribution, contributionType) => {
  if (contributionType === CONTRIBUTION_TYPES.fixed) {
    return (
      <>
        <BodyText>
          <strong>${contribution.employeeFixedAmount}</strong>&nbsp;for employees
        </BodyText>
        <BodyText>
          <strong>${contribution.dependentFixedAmount}</strong>&nbsp;for dependents
        </BodyText>
      </>
    );
  }
  return (
    <>
      <BodyText>
        <strong>{contribution.employeePercentage}%</strong>&nbsp;for employees
      </BodyText>
      <BodyText>
        <strong>{contribution.dependentPercentage}%</strong>&nbsp;for dependents
      </BodyText>
    </>
  );
};
